import Tree from "../Tree";
import m, {Vnode} from "mithril";
import ICustomFormSettings from "../../ICustomFormSettings";
import {loadJsonFromString, normalizeString} from "../../shared/helpers";
import {TextboxItem} from "../../../model/items/textbox";
import TNode from "./TNode";
import TreeNode from "./TreeNode";



export default class TreeLeaves extends Tree {

    private tree: null|TNode[] = null;
    private treeSettings: any;
    private readonly ci_groups: TextboxItem[];
    private readonly ci_values: TextboxItem[];

    private nodes: null|TreeNode[] = null;

    private loaded = false;
    private hasError = false;

    constructor(settings: ICustomFormSettings) {
        super(settings);
        let loadCounter = 0;
        const afterJsonLoaded = () => {
            loadCounter++;
            if (loadCounter === 2) {
                this.loaded = true;
                console.log(this.treeSettings, this.tree);
                m.redraw();
            }
        }
        loadJsonFromString(settings.form.aux1, settings.form.questionary, (data: TNode[]) => {
            this.tree = data;
            this.nodes = data.map(node => new TreeNode(null, node, path => this.isSelected(path), path => this.onSet(path)))
            afterJsonLoaded();
        }, () => this.hasError = true)
        loadJsonFromString(settings.form.aux2, settings.form.questionary, data => {
            this.treeSettings = data;
            afterJsonLoaded();
        }, () => this.treeSettings = {});
        this.ci_values = <TextboxItem[]>this.settings.form.grid.layout[0]
            ?.map(cell => cell.cellItems[0])
            .filter(ci => ci instanceof TextboxItem) ?? [];
        this.ci_groups = <TextboxItem[]>this.settings.form.grid.layout[1]
            .map(cell => cell.cellItems[0])
            .filter(ci => ci instanceof TextboxItem) ?? [];
    }

    private search(phrase: string): void {
        this.nodes?.forEach(node => node.search(normalizeString(phrase)));
    }

    private isSelected(nodePath: TNode[]): boolean {
        return nodePath.every((node,i) => node.label && node.label === this.ci_groups[i]?.getVariable());
    }

    private onSet(nodePath: TNode[]): void {
        this.ci_groups.forEach((ci, i) => ci.setVariable(nodePath[i]?.label ?? ''));
        const values = nodePath[nodePath.length - 1]?.values ?? [];
        this.ci_values.forEach((ci, i) => ci.setVariable(values[i] ?? ''));
    }

    private viewLoading(): Vnode|null {
        if (this.loaded) {
            return null;
        }
        const messages = this.settings.form.questionary.messages;
        return m('.loading', {}, [
            m('.loader', {}, [
                m('.loader-spinner'),
                m('.loader-message', {}, m.trust(messages.get('loading'))),
            ])
        ]);
    }

    private viewError(): Vnode|null {
        if (!this.hasError) {
            return null;
        }
        return m('.', {}, [
            m('.', {}, 'Cannot load settings of question. Please check your internet connection.'),
            m('button', {
                onclick: () => {
                    this.settings.form.questionary.prev();
                    this.settings.form.questionary.next();
                }
            }, 'Reload question')
        ]);
    }

    private viewSearch(): Vnode {
        const questionary = this.settings.form.questionary;
        return m('.search', {}, [
            m('input', {
                type: 'search',
                placeholder: questionary.renderText(questionary.messages.get('search')),
                oninput: (e: InputEvent) => this.search( (<HTMLInputElement>e.currentTarget).value ),
            })
        ]);
    }

    private viewTree(): Vnode {
        return m('.tree', {}, this.nodes?.map(node => m(node)) ?? null);
    }

    private viewNoItemFound(): null|Vnode {
        const questionary = this.settings.form.questionary;
        if (this.nodes?.length && this.nodes.every(node => !node.isVisible)) {
            return m('.', {}, [
                m('.', {}, questionary.messages.get('noItemsFound')),
                m('button', {
                    onclick: () => this.search(''),
                }, questionary.messages.get('resetFilter')),
            ])
        }

        return null;
    }

    public view(): Vnode {

        return this.viewLayout([
            this.viewError(),
            this.viewLoading(),
            this.viewSearch(),
            this.viewTree(),
            this.viewNoItemFound(),
        ]);
    }
}